module.exports = __webpack_public_path__ + "bb1f34afaf504a7b3c8977320602631e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/quiz-icons/open-ss.png
// module id = 3392
// module chunks = 0